export const createRuntimePaths = () => {
    const defaultPaths = {
        apiPath: '/',
        contextPath: '/',
        resourcePath: '/',
    };

    if (typeof document === 'undefined') {
        return defaultPaths;
    }

    const contextPathEl = document.getElementById('context-path');
    if (!contextPathEl) {
        return defaultPaths;
    }

    const href = contextPathEl.getAttribute('href') || '/';
    return {
        apiPath: href,
        contextPath: href,
        resourcePath: href,
    };
};
